export const codeSnippets = [
	{
		id: 1,
		title: "StateModel.cs",
		language: "csharp",
		file: "StateModel.cs",
		description: "A generic state model for use in Unity UI, similar to Redux."
	},
	{
		id: 2,
		title: "PhaseIndicatorView.cs",
		language: "csharp", 
		file: "PhaseIndicatorView.cs",
		description: "A view that updates a turn based combat phase indicator."
	},
	{
		id: 3,
		title: "Stock.lua",
		language: "lua", 
		file: "Stock.lua",
		description: "Updates a timer to indicate when stock refreshes."
	},
	{
		id: 4,
		title: "AutonomousNode.cs",
		language: "csharp",
		file: "AutonomousNode.cs",
		description: "An autonomous enemy AI for a strategy game (Crusade) in Unity."
	},
	{
		id: 5,
		title: "CharacterAttack.cs",
		language: "csharp",
		file: "CharacterAttack.cs",
		repoUrl: "https://github.com/eb00t/Unsalted-Raw-Broccoli",
		description: "A controller for character attack actions in a 2.5D Unity game."
	}
];